import { format, parseISO } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

export function date(string: string, mask = 'dd/MM/yyyy') {
  return format(parseISO(string), mask, { locale: ptBR }) || null
}

export function setDateFromDay(day: number) {
  const todayDate = new Date()
  todayDate.setDate(day)
  return todayDate
}
